module.exports = __webpack_public_path__ + "img/logo-pagarme.f40e8361.svg";